<template>
  <ImageHeader :headerTitle="'Auftragsübersicht'" :imageSource="require('../assets/leeb-images3/pic1.jpg')">
    <v-row>
      <v-col lg="6" cols="12">
        <v-card style="height: 100%;" data-voverviewtourstep="1" elevation="0">
          <v-card-text>
            <h3 class="primary--text">
              Stammdaten
            </h3>
            <v-skeleton-loader v-if="!masterOrderLoaded" type="text" class="mt-3"></v-skeleton-loader>
            <v-list ense v-else>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <span>{{ getCustomerAddressation(masterOrder.Customer) }} (<abbr title="Kundennummer">Kd.Nr.</abbr>:
                    {{ masterOrder.Customer.CustomerNumber }})</span>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-skeleton-loader v-if="!masterOrderLoaded" type="list-item-two-line"></v-skeleton-loader>
            <v-list dense v-else>
              <v-list-item v-for="communicationEntry in masterOrder.Customer.Communications"
                v-bind:key="communicationEntry.Id" dense>
                <v-list-item-icon>
                  <v-icon v-if="communicationEntry.CommunicationTypeId == 2">mdi-phone</v-icon>
                  <v-icon v-else-if="communicationEntry.CommunicationTypeId == 5">mdi-cellphone</v-icon>
                  <v-icon v-else-if="communicationEntry.CommunicationTypeId == 1">mdi-email</v-icon>
                  <v-icon v-else>mdi-email</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  {{ communicationEntry.Value }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <br>
            <b>Rechnungsadresse</b>
            <v-skeleton-loader v-if="!masterOrderLoaded" type="list-item"></v-skeleton-loader>
            <v-list dense v-else>
              <v-list-item v-if="invoiceAddresses.length > 0">
                <v-list-item-icon>
                  <v-icon>mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{ invoiceAddresses[0].Street }}<br>{{ invoiceAddresses[0].Country.CountryCodeIso3
                  }}-{{ invoiceAddresses[0].Zip }} {{ invoiceAddresses[0].City }}</v-list-item-content>
              </v-list-item>
              <v-list-item v-else>
                <v-list-item-content>keine hinterlegt</v-list-item-content>
              </v-list-item>
            </v-list>
            <br>
            <b>Lieferaddresse</b>
            <v-skeleton-loader v-if="!masterOrderLoaded" type="list-item"></v-skeleton-loader>
            <v-list dense v-else>
              <v-list-item v-if="deliveryAddresses.length > 0">
                <v-list-item-icon>
                  <v-icon>mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{ deliveryAddresses[0].Street }}<br>{{
                  deliveryAddresses[0].Country.CountryCodeIso3 }}-{{ deliveryAddresses[0].Zip }} {{
                  deliveryAddresses[0].City }}</v-list-item-content>
              </v-list-item>
              <v-list-item v-else>
                <v-list-item-content>keine hinterlegt</v-list-item-content>
              </v-list-item>
            </v-list>
            <br>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col lg="6" cols="12">
        <v-row>
          <v-col cols="12">
            <v-card class="" data-voverviewtourstep="2" elevation="0">
              <v-card-text>
                <h3 class="primary--text">
                  Ihr Leeb-Berater
                </h3>
                <v-skeleton-loader v-if="!masterOrderLoaded" type="list-item-two-line" class="mt-3"></v-skeleton-loader>
                <v-list dense v-else>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      {{ masterOrder.Agent.DisplayName }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="masterOrder.Agent.Email != undefined">
                    <v-list-item-icon>
                      <v-icon>mdi-email</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <a :href='"mailto:" + masterOrder.Agent.Email'>{{ masterOrder.Agent.Email }}</a>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="masterOrder.Agent.PhoneNumber != undefined">
                    <v-list-item-icon>
                      <v-icon>mdi-phone</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <a :href='"tel:" + masterOrder.Agent.PhoneNumber'>{{ masterOrder.Agent.PhoneNumber }}</a>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="" data-voverviewtourstep="3" elevation="0">
              <v-card-text>
                <h3 class="primary--text">
                  Ihr Kontakt bei Leeb
                </h3>
                <v-skeleton-loader v-if="!masterOrderLoaded" type="list-item-two-line" class="mt-3"></v-skeleton-loader>
                <v-list dense v-else>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      {{ masterOrder.Clerk.DisplayName }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="masterOrder.Clerk.Email != undefined">
                    <v-list-item-icon>
                      <v-icon>mdi-email</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <a :href='"mailto:" + masterOrder.Clerk.Email'>{{ masterOrder.Clerk.Email }}</a>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="masterOrder.Clerk.PhoneNumber != undefined">
                    <v-list-item-icon>
                      <v-icon>mdi-phone</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <a :href='"tel:" + masterOrder.Clerk.PhoneNumber'>{{ masterOrder.Clerk.PhoneNumber }}</a>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

    </v-row>

    <v-row>
      <v-col>

        <v-card elevation="0">
          <v-data-table :headers="workOrdersHeader" :items="filterCanceledWorkOrders(masterOrder.WorkOrders)"
            :loading="!masterOrderLoaded" :hide-default-footer="true" :hide-default-header="false" show-select
            single-select :item-key="'Id'" v-model="selectedWorkOrders"
            @click:row="(row, itemRow) => { itemRow.select(true); }">
            <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
              <v-simple-checkbox :value="isSelected" off-icon="" on-icon="mdi-play" color="primary" :ripple="false"
                @input="select($event)" />
            </template>
            <template v-slot:[`item.state`]="{ item }">
              <v-chip small>{{ translateStatus(calculateStatus(item)) }}</v-chip>
            </template>
            <template v-slot:[`item.delivery`]="{ item }">
              <span v-if="getDelivery(item) != null"><DeliveryInstallationDisplay :date="new Date(Date.parse(getDelivery(item)))"></DeliveryInstallationDisplay></span>
              <span v-else>&nbsp;</span>
            </template>
            <template v-slot:[`item.assembly`]="{ item }">
              <span v-if="getAssembly(item) != null"><DeliveryInstallationDisplay :date="new Date(Date.parse(getAssembly(item)))"></DeliveryInstallationDisplay></span>
              <span v-else>&nbsp;</span>
            </template>
            <template v-slot:[`item.actions`]="{ }">
              <v-icon @click="$router.push({path: '/messages'}).catch(() => {})">
                mdi-email-outline
              </v-icon>
            </template>
          </v-data-table>
        </v-card>

      </v-col>
    </v-row>

    <v-row v-if="showTimeLine">
      <v-col cols="12">
        <v-card elevation="0">
          <v-card-title>Zeitleiste</v-card-title>
          <v-card-text>
            <TimeLine :workOrderId="this.selectedWorkOrders[0].Id"></TimeLine>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-btn fab dark large color="primary" fixed right bottom @click="dialog.show = !dialog.show">
      <v-icon dark>mdi-email-fast</v-icon>
    </v-btn>
    <v-dialog v-model="dialog.show" max-width="500px">
      <v-card elevation="0">
        <v-card-title>Nachricht schreiben</v-card-title>
        <v-card-text>
          <v-text-field :value="dialog.receiver" outlined readonly label="Sachbearbeiter:in"></v-text-field>
          <v-textarea v-model="dialog.textdata" outlined>
            <template v-slot:label>
              <span>Ihre Nachricht</span>
            </template>
          </v-textarea>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="sendNewMessage()">Senden<v-icon right>mdi-send</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-tour name="VOverviewTour" :steps="vOverviewTourSteps"></v-tour>
  </ImageHeader>
</template>

<script>
import TimeLine from '../components/TimeLine.vue';
import ImageHeader from '../components/ImageHeader.vue';
import dataAssembler from '../plugins/dataAssembler';
import { FieldOrderTypes } from '../plugins/customer-portal/types';
import DeliveryInstallationDisplay from '../components/DeliveryInstallationDisplay.vue';

export default {
  components: { TimeLine, ImageHeader, DeliveryInstallationDisplay },
  name: "Overview",
  data: () => ({
    masterOrder: {},
    masterOrderLoaded: false,
    workOrdersHeader: [
      { text: 'Auftragsnummer', value: 'DisplayName', sortable: false, align: 'start' },
      { text: 'Artikel', value: 'MainItemName', sortable: false },
      { text: 'Menge', value: 'QuantityOrder', sortable: false },
      { text: 'Phase', value: 'state', sortable: false },
      { text: 'Lieferung', value: 'delivery', sortable: false },
      { text: 'Montage', value: 'assembly', sortable: false },
      { text: '', value: 'actions', sortable: false },
    ],
    selectedWorkOrders: [],
    showTimeLine: false,
    orderStates: [],
    orderStatesLoaded: false,
    deliveryAddresses: [],
    invoiceAddresses: [],
    documentData: [],
    vOverviewTourSteps: [
      {
        target: '[data-voverviewtourstep="0"]',
        header: {
          title: 'Hier ist die Kopfzeile!',
        }
      },
      {
        target: '[data-voverviewtourstep="1"]',
        header: {
          title: 'Hier sind die Stammdaten ersichtlich!',
        },
        content: 'Ihre Daten, welche Sie uns mittgeteilt haben.'
      },
      {
        target: '[data-voverviewtourstep="2"]',
        header: {
          title: 'Der Verkäufer dieses Auftrags',
        }
      },
      {
        target: '[data-voverviewtourstep="3"]',
        header: {
          title: 'Der Sachbearbeiter dieses Auftrags',
        }
      },
      {
        target: '[data-voverviewtourstep="4"]',
        content: 'Die einzelnen Punkte in der Zeitleiste <i>sind</i> anklickbar!',
        params: {
          placement: 'top'
        }
      }
    ],
    token: "",
    dialog: {
      show: false,
      receiver: "",
      textdata: "",
    }
  }),
  mounted() {
    this.$tours['VOverviewTour'].start()
  },
  methods: {
    filterCanceledWorkOrders(workOrders) {
      return dataAssembler.filterCanceledWorkOrders(workOrders);
    },
    getCustomerAddressation(customer) {
      let result = "";

      if (customer.Salutation != null) {
        result += customer.Salutation.Description + " ";
      }
      
      if (customer.Title != null) {
        result += customer.Title.Description + " ";
      }
      
      result += customer.FamilyName + " ";
      result += customer.FirstName;

      return result;
    },
    /**
     * Get the expected delivery date from the Tour's start date.
     * @returns {string} A Date
     */
    getDelivery(workOrder) {
      let deliveryTypeIds = [
        FieldOrderTypes.LK.Id,
        FieldOrderTypes.LL.Id,
        FieldOrderTypes.LM.Id
      ];
      
      let wofo = workOrder.WorkOrderFieldOrders.find(x => x.FieldOrder && deliveryTypeIds.findIndex(y => y == x.FieldOrder.FieldOrderTypeId) != -1);
      if (wofo == null) {
        return null;
      }

      if (wofo.FieldOrder.Tour.StartDate != null) {
        return wofo.FieldOrder.Tour.StartDate;
      } else if (wofo.FieldOrder.Tour.CalendarWeek.DateFrom != null) {
        return wofo.FieldOrder.Tour.CalendarWeek.DateFrom;
      } else {
        return null;
      }
    },
    /**
     * Get the expected assembly date from the Tour's start date.
     * @returns {string} A Date
     */
    getAssembly(workOrder) {
      let assemblyTypeIds = [
        FieldOrderTypes.LM.Id,
        FieldOrderTypes.M.Id
      ];
      
      let wofo = workOrder.WorkOrderFieldOrders.find(x => x.FieldOrder && assemblyTypeIds.findIndex(y => y == x.FieldOrder.FieldOrderTypeId) != -1);
      if (wofo == null) {
        return null;
      }

      if (wofo.FieldOrder.Tour.StartDate != null) {
        return wofo.FieldOrder.Tour.StartDate;
      } else if (wofo.FieldOrder.Tour.CalendarWeek.DateFrom != null) {
        return wofo.FieldOrder.Tour.CalendarWeek.DateFrom;
      } else {
        return null;
      }
    },
    /**
     * Calculates the state of a given WorkOrder.
     * @return {Number} A number between 0 and 5
     */
    calculateStatus(workOrder) {
      let timeLineConfig = dataAssembler.calculateTimeLineConfig(workOrder.WorkOrderFieldOrders, workOrder.Events, workOrder.WorkOrderFlag, workOrder.IsInstallationOrder);

      // First orange ...
      let lastTimelinePhase = timeLineConfig.colors.findIndex((value) => value === "orange");

      // ... or last green.
      if(lastTimelinePhase === -1) {
        lastTimelinePhase = timeLineConfig.colors.lastIndexOf("green");
      }

      return lastTimelinePhase;
    },
    /**
     * Translates a given WorkOrder state to a name.
     * @returns {String} The coressponding name
     * @see calculateStatus
     */
    translateStatus(id) {
      switch(id) {
        case 0:
          return "Auftragsbearbeitung";
        case 1:
          return "Aufmaß";
        case 2:
          return "Konstruktion";
        case 3:
          return "Produktion";
        case 4:
          return "Lieferung";
        case 5:
          return "Montage";
        default:
          return "Unbekannt";
      }
    },
    sendNewMessage() {
      this.$http(
        dataAssembler.contructNewMessageAxiosQuery(this.dialog.textdata, this.masterOrder.Id, this.$store.getters.customerNumber(), this.$store.getters.token())
      ).then(() => {
        this.dialog.show = false;
        this.$snackbar('Neue Nachricht erstellt!', 'green darken-1');
      }).catch((error) => {
        this.dialog.show = false;
        console.error(error);
        this.$snackbar('Ein Fehler ist aufgetreten', 'red darken-1');
      });
    },
    // #region data loading
    loadMasterOrderData() {
      this.$http(
        dataAssembler.contructMasterOrderAxiosQuery(this.$route.query.id, this.$store.getters.customerNumber(), this.$store.getters.token())
      ).then((response) => {
        this.masterOrder = response.data;
        this.masterOrderLoaded = true;
      }).catch((error) => {
        console.error(error);

        // 'Forbidden' redirect to the dedicated error page
        if (error.response.status == 403) {
          this.$router.push({path: '/error', query: { errorCode: 20403, targetRoute: this.$route.fullPath }}).catch(() => {})
        }

        this.loginSnackbarText = "Error on fetching order!";
        this.loginSnackbarShown = true;
      });
    },
    loadOrderStates() {
      this.$http({
        method: "get",
        url: "/api/v1/OrderStates",
        headers: { Authorization: "Bearer " + this.$store.getters.token() },
      }).then((response) => {
        this.orderStates = response.data;
        this.orderStatesLoaded = true;
      }).catch((error) => {
        console.error(error);
        this.$snackbar('Ein Fehler ist aufgetreten', 'red darken-1');
      });
    },
    // #endregion
    // #region Event handling
    handleSelectedWorkOrderChanges() {
      if (this.selectedWorkOrders.length == 0) {
        this.showTimeLine = false;
      } else {
        this.showTimeLine = true;
      }
    }
    // #endregion
  },
  created() {
    this.$store.commit('initFinished', false);

    this.$msal.getSilentToken(this.$msal.getAllAccounts()[0], [
      "offline_access",
      "openid",
      "https://leebcustomer.onmicrosoft.com/customerportal.api/Orders.Read",
    ]).then((rep) => {
      this.$store.commit('token', rep.accessToken);
      this.$store.commit('initFinished', true);
    }).catch(() => {
      this.$router.push({ path: "/logout" });
    });
  },
  watch: {
    '$store.state.initFinished': function(val) {
      if (val == true) {
        this.loadMasterOrderData();
      }
    },
    token() {
    },
    masterOrder() {
      this.selectedWorkOrders.push(this.masterOrder.WorkOrders.find(x => x.Id == this.masterOrder.Id));
      this.loadOrderStates();
      this.deliveryAddresses = dataAssembler.getDeliveryAddresses(this.masterOrder.Customer.Addresses);
      this.invoiceAddresses = dataAssembler.getInvoiceAddresses(this.masterOrder.Customer.Addresses);
      this.dialog.receiver = this.masterOrder.Clerk.DisplayName;
    },
    selectedWorkOrders() {
      this.handleSelectedWorkOrderChanges();
    }
  }
};
</script>
